// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tap-terminal {
  /* custom scrollbar */
}
.tap-terminal::-webkit-scrollbar {
  width: 12px;
  box-shadow: inset 2px 1px 4px -1px rgba(0, 0, 0, 0.5);
}
.tap-terminal::-webkit-scrollbar-track {
  background-color: transparent;
}
.tap-terminal::-webkit-scrollbar-thumb {
  background-color: var(--color-scrollbar-thumb);
  border: 6px solid transparent;
}
.tap-terminal::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-scrollbar-thumbHover);
}

.tap-terminal:hover::-webkit-scrollbar-thumb {
  background-color: var(--color-scrollbar-thumbActive);
  border: 6px solid transparent;
}
.tap-terminal::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-scrollbar-thumbHover);
}

.tap-terminal {
  margin-top: 4px;
  margin-bottom: 4px;
  overflow: auto;
  height: calc(100% - 20px);
}
.tap-terminal .terminal-input {
  font-family: Ubuntu-L, sans-serif;
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  text-wrap: nowrap;
}
.tap-terminal .terminal-input .inputText {
  background-color: transparent;
  border: 0;
  outline: none;
  color: var(--color-dropdown-footer-terminal-text);
  margin-left: 6px;
  font-family: Ubuntu-L, sans-serif;
  font-size: 12px;
  padding: 0;
  text-wrap: wrap;
  word-break: break-all;
}
.tap-terminal .terminal-input .inputText .inputText-text {
  line-height: 1.2;
  text-wrap: pretty;
}
.tap-terminal .terminal-input .inputText .inputText-text-valid {
  color: var(--color-navLeft-button-active);
}
.tap-terminal .terminal-input .inputText .inputText-text-invalid {
  color: rgb(210, 53, 53);
}
.tap-terminal .terminal-input .noPs {
  color: #E2E2E2;
  margin-left: 0px;
}
.tap-terminal .terminal-input input {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/theme/scrollbar.scss","webpack://./src/components/footer/components/taps/terminal.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;ACCF;ADAE;EACE,WAAA;EAGA,qDAAA;ACEJ;ADCE;EACE,6BAAA;ACCJ;ADEE;EACE,8CAAA;EACA,6BAAA;ACAJ;ADGE;EACE,mDAAA;ACDJ;;ADME;EACE,oDAAA;EACA,6BAAA;ACHJ;ADME;EACE,mDAAA;ACJJ;;AAxBA;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AA2BF;AAvBE;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EAEA,aAAA;EACA,mBAAA;EACA,iBAAA;AAwBJ;AAtBI;EACE,6BAAA;EACA,SAAA;EACA,aAAA;EACA,iDAAA;EACA,gBAAA;EACA,iCAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;AAwBN;AAtBM;EACE,gBAAA;EACA,iBAAA;AAwBR;AArBM;EACE,yCAAA;AAuBR;AApBM;EACE,uBAAA;AAsBR;AAlBI;EACE,cAAA;EACA,gBAAA;AAoBN;AAjBI;EACE,sBAAA;AAmBN","sourcesContent":["%scrollbar {\n  /* custom scrollbar */\n  &::-webkit-scrollbar {\n    width: 12px;\n    -webkit-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    -moz-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumb);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}\n\n%scrollbarHover {\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumbActive);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}","@import '../../../../theme/scrollbar.scss';\n\n.tap-terminal {\n  margin-top: 4px;\n  margin-bottom: 4px;\n  overflow: auto;\n  height: calc(100% - 20px);\n\n  @extend %scrollbar;\n\n  .terminal-input {\n    font-family: Ubuntu-L, sans-serif;\n    padding: 2px 8px;\n    font-size: 12px;\n\n    display: flex;\n    flex-direction: row;\n    text-wrap: nowrap;\n\n    .inputText {\n      background-color: transparent;\n      border: 0;\n      outline: none;\n      color: var(--color-dropdown-footer-terminal-text);\n      margin-left: 6px;\n      font-family: Ubuntu-L, sans-serif;\n      font-size: 12px;\n      padding: 0;\n      text-wrap: wrap;\n      word-break: break-all;\n\n      .inputText-text {\n        line-height: 1.2;\n        text-wrap: pretty;\n      }\n\n      .inputText-text-valid {\n        color: var(--color-navLeft-button-active);\n      }\n\n      .inputText-text-invalid {\n        color: rgb(210, 53, 53);\n      }\n    }\n\n    .noPs {\n      color: #E2E2E2;\n      margin-left: 0px;\n    }\n\n    input {\n      width: 100% !important;\n    }\n  }\n}\n\n.tap-terminal:hover {\n  @extend %scrollbarHover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
